import { Component, Input } from '@angular/core';
import { FabricComposition } from '../../../models/item/greige';
import { Composition } from '../../../models/yarn/composition';
import { LocaleHelperService } from '../../../services/locale-helper.service';

@Component({
  selector: 'app-card-composition',
  templateUrl: './card-composition.component.html',
  styleUrl: './card-composition.component.scss',
})
export class CardCompositionComponent {
  @Input() fabricComposition: FabricComposition[] = [];
  @Input() allCompositions: Composition[] = [];
  constructor(private localeHelperService: LocaleHelperService) {}
  getCompositionName(code: string): string {
    const composition = this.allCompositions.find((c) => c.code.toLowerCase() === code.toLowerCase());
    return composition ? this.localeHelperService.getLocalizedValue(composition.name) : code;
  }

  getCompositionColor(code: string): string {
    switch (code.toLowerCase()) {
      case 'cotton':
        return '#001a70';
      case 'poly':
        return '#ef4444';
      case 'recycledblackpoly':
        return '#5fa535';
      case 'rayon':
        return '#009999';
      case 'blackpoly':
        return '#5AA29D';
      case 'polyrecycle':
        return '#5AA29D';
      default:
        return '#777';
    }
  }
}
